import { render, staticRenderFns } from "./editTitle.vue?vue&type=template&id=18c4a617&scoped=true&"
import script from "./editTitle.vue?vue&type=script&lang=js&"
export * from "./editTitle.vue?vue&type=script&lang=js&"
import style0 from "./editTitle.vue?vue&type=style&index=0&id=18c4a617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4a617",
  null
  
)

export default component.exports